import { Toaster } from 'sonner';

export function AppToaster() {
  return (
    // react-aria "top layer": clicks on a toast must not be swallowed or
    // treated as an outside-interaction while a modal overlay is open
    // (react-aria checks [data-react-aria-top-layer] in useInteractOutside +
    // ariaHideOutside). Value must be the string "true" — ariaHideOutside's
    // observer path checks dataset.reactAriaTopLayer === 'true'.
    <div data-react-aria-top-layer='true'>
      <Toaster
        position='bottom-right'
        toastOptions={{
          style: {
            background: 'var(--color-bg-primary)',
            border: '1px solid var(--color-border-secondary)',
            color: 'var(--color-fg-primary)',
            boxShadow:
              '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
            borderRadius: '8px',
            fontSize: '14px',
            padding: '12px 16px',
          },
          classNames: {
            success:
              '[&_[data-icon]]:text-success-500 [&_[data-icon]]:bg-success-50 [&_[data-icon]]:rounded-full [&_[data-icon]]:p-1',
            error:
              '[&_[data-icon]]:text-error-500 [&_[data-icon]]:bg-error-50 [&_[data-icon]]:rounded-full [&_[data-icon]]:p-1',
            warning:
              '[&_[data-icon]]:text-warning-500 [&_[data-icon]]:bg-warning-50 [&_[data-icon]]:rounded-full [&_[data-icon]]:p-1',
            description: 'text-fg-tertiary text-xs mt-1',
          },
        }}
        gap={16}
        offset={16}
      />
    </div>
  );
}
